<section id="insights" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="insights-heading">
  <div class="section__head">
    <div class="section__headings">
      <!-- Titre composé des deux titres de cartes : la section n'a pas de
           libellé propre, elle annonce ce qu'elle met côte à côte. -->
      <h2 class="section__title" id="insights-heading">{{ 'strengths.title' | reportT }} · {{ 'weaknesses.title' | reportT }}</h2>
    </div>
  </div>

  <div class="insights-grid">
    <article class="card card--interactive insight-card insight-card--strength" data-print-block>
      <div class="insight-card__head">
        <span class="insight-card__icon"><svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/></svg></span>
        <div class="insight-card__headings">
          <h3 class="insight-card__title">{{ 'strengths.title' | reportT }}</h3>
          <p class="insight-card__subtitle">{{ 'strengths.subtitle' | reportT: strengthVars() }}</p>
        </div>
      </div>
      @if (strengths().length > 0) {
        <ul class="insight-list">
          @for (item of strengths(); track item.competencyId) {
            <li class="insight-item reveal reveal--fade-in-x" s2eReveal [revealDelay]="$index * 40">
              <span class="insight-item__main">
                <span class="insight-item__dot" aria-hidden="true"></span>
                <span class="insight-item__text">
                  <!-- Le descripteur, pas le libellé du référentiel : ces deux
                       colonnes se lisent d'un coup d'œil, et « Identify
                       opinion » n'apprend rien à qui ne connaît pas le
                       programme. Le code court reste, il sert de renvoi vers
                       le tableau détaillé. -->
                  <span class="insight-item__name">{{ item.skillDescriptor }}</span>
                  <!-- `dir="auto"` : un code mêle une lettre et des chiffres,
                       et l'algorithme bidi le retourne sans cet indice. -->
                  <span class="insight-item__code" dir="auto">{{ item.shortCode }}</span>
                </span>
              </span>
            </li>
          }
        </ul>
      } @else {
        <p class="insight-card__empty">{{ 'strengths.empty' | reportT }}</p>
      }
    </article>

    <article class="card card--interactive insight-card insight-card--weakness" data-print-block>
      <div class="insight-card__head">
        <span class="insight-card__icon"><svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg></span>
        <div class="insight-card__headings">
          <h3 class="insight-card__title">{{ 'weaknesses.title' | reportT }}</h3>
          <p class="insight-card__subtitle">{{ 'weaknesses.subtitle' | reportT: gapVars() }}</p>
        </div>
      </div>
      @if (gaps().length > 0) {
        <ul class="insight-list">
          @for (item of gaps(); track item.competencyId) {
            <li class="insight-item reveal reveal--fade-in-x" s2eReveal [revealDelay]="$index * 40">
              <span class="insight-item__main">
                <span class="insight-item__dot" aria-hidden="true"></span>
                <span class="insight-item__text">
                  <span class="insight-item__name">{{ item.skillDescriptor }}</span>
                  <span class="insight-item__code" dir="auto">{{ item.shortCode }}</span>
                </span>
              </span>
            </li>
          }
        </ul>
      } @else {
        <p class="insight-card__empty">{{ 'weaknesses.empty' | reportT }}</p>
      }
    </article>
  </div>
</section>
